export const selectFilter = filter => {
    return {
        type: 'FILTER_SELECTED',
        payload: filter
    };
};

export const selectShift = shift => {
    return {
        type: 'SHIFT_SELECTED',
        payload: shift
    }
}

export const clearSelectedShifts = () => {
    return {
        type: 'CLEAR_SHIFTS'
    }
}

export const updateFilterList = payload => {
    return {
        type: 'UPDATE_FILTERS_LIST',
        payload: payload,
    }
}

export const updateLocationFilterList = payload => {
    return {
        type: 'UPDATE_LOCATION_FILTERS_LIST',
        payload: payload,
    }
}

export const updateJobFilterList = payload => {
    return {
        type: 'UPDATE_JOB_FILTERS_LIST',
        payload: payload,
    }
}

export const selectOpenShift = shift => {
    return {
        type: 'OPENSHIFT_SELECTED',
        payload: shift,
    }
}

export const clearSelectedOpenShifts = () => {
    return {
        type: 'CLEAR_OPENSHIFTS'
    }
}

export const updateEmployeeDashboardData = (payload) => {
    return {
        type: 'UPDATE_EMPLOYEE_DASHBOARD_DATA',
        payload,
    }
}

export const appendManagerSettings = (payload) => {
    return {
        type: 'APPEND_MANAGER_SETTINGS',
        payload,
    }
}

export const clearManagerSettings = () => {
    return {
        type: 'CLEAR_MANAGER_SETTINGS'
    }
}

export const updateTimeOffRequestSubtypes = (payload) => {
    return {
        type: 'UPDATE_TOR_SUBTYPES',
        payload,
    }
}

export const updateLoading = (payload) => {
    return {
        type: 'UPDATE_LOADING',
        payload,
    }
}

export const updateLoadingPrivateEmployeesValidation = (payload) => {
    return {
        type: 'UPDATE_LOADING_PRIVATE_EMPLOYEE_VALIDATION',
        payload,
    }
}

export const updateLoadingPrivateEmployeesNames = (payload) => {
    return {
        type: 'UPDATE_LOADING_PRIVATE_EMPLOYEE_NAMES',
        payload,
    }
}

export const updateSnackbar = (payload) => {
    return {
        type: 'UPDATE_SNACKBAR',
        payload,
    }
}

export const updatePerson = payload => {
    return {
        type: 'UPDATE_PERSON',
        payload,
    }
}

export const updateDateRange = payload => {
    return {
        type: 'UPDATE_DATE_RANGE',
        payload,
    }
}

export const updatePartialDates = payload => {
    return {
        type: 'UPDATE_PARTIAL_DATES',
        payload,
    }
}

export const updateProposalPartialDates = payload => {
    return {
        type: 'UPDATE_PROPOSAL_PARTIAL_DATES',
        payload,
    }
}


export const updateRefreshedDates = payload => {
    return {
        type: 'UPDATE_REFRESHED_DATES',
        payload
    }
}

export const updateGlobalConfigs = payload => {
    return {
        type: 'UPDATE_GLOBAL_CONFIGS',
        payload
    }
}

export const updateBuildInfos = payload => {
    return {
        type: 'UPDATE_BUILD_INFOS',
        payload
    }
}

export const updateDismissNotificationData = payload => {
    return {
        type: 'UPDATE_DISMISS_NOTIFICATION_DATA',
        payload
    }
}

export const resetDismissNotificationData = () => {
    return {
        type: 'RESET_DISMISS_NOTIFICATION_DATA',
    }
}

export const updateSidePanel = () => { return { type: 'TOGGLE_SIDE_PANEL' } }
export const closeSidePanel = payload => { return { type: 'CLOSE_SIDE_PANEL', payload } }
export const updateSidePanelData = payload => { return { type: 'UPDATE_SIDE_PANEL_DATA', payload, } }
export const updateEmployeeToOfferList = payload => { return { type: 'UPDATE_EMPLOYEES_TO_OFFER_LIST', payload, } }
export const resetAndAddEmployeesToOfferList = payload => { return { type: 'RESET_AND_ADD_EMPLOYEES_TO_EMPLOYEES_TO_OFFER_LIST', payload, } }
export const addOrUpdatevalidatedEmployeesToOfferList = payload => { return { type: 'ADD_OR_UPDATE_VALIDATED_EMPLOYEES_IN_EMPLOYEES_TO_OFFER_LIST', payload, } }
export const addOrUpdateEmployeesToOfferList = payload => { return { type: 'ADD_OR_UPDATE_EMPLOYEES_IN_EMPLOYEES_TO_OFFER_LIST', payload, } }
export const updateEmployeesToOfferList = payload => { return { type: 'UPDATE_EMPLOYEES_IN_EMPLOYEES_TO_OFFER_LIST', payload, } }
export const resetValidatedEmployeesToOfferList = () => { return { type: 'RESET_VALIDATED_EMPLOYEES_TO_OFFER_LIST' } }
export const resetEmployeesToOfferList = () => { return { type: 'RESET_EMPLOYEES_TO_OFFER_LIST' } }
export const addPrivateEmployeeProposableShiftsList = payload => { return { type: 'ADD_PRIVATE_EMPLOYEE_SHIFT_TO_PROPOSE_LIST', payload, } }
export const selectProposablePrivateEmployee = payload => { return { type: 'SELECT_PROPOSABLE_PRIVATE_EMPLOYEE', payload, } }
export const resetProposablePrivateEmployee = () => { return { type: 'RESET_PROPOSABLE_SHIFTS_BY_OFFEROR', } }
export const updateCheckedProposableShifts = payload => { return { type: 'UPDATE_CHECKED_PROPOSABLE_SHIFT', payload, } }
export const updateValidProposalShifts = payload => { return { type: 'UPDATE_VALID_PROPOSAL_SHIFTS', payload, } }
export const updateSelectedActionIndex = payload => { return { type: 'UPDATE_ACTION_INDEX', payload, } }
export const setSignalRConnection = payload => { return { type: 'SET_SIGNALR_CONNECTION', payload } }

